import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._b({
    staticClass: "v-button-group"
  }, 'div', _vm.$attrs, false), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-716e7e4c_0", {
    source: ".v-button-group{display:inline-flex}.v-button-group .v-button{margin-right:1px;border-radius:0;flex-shrink:0;background-color:transparent;border-style:solid;border-width:thin;border-color:var(--g-color-gray-200);box-shadow:none;color:var(--g-color-gray-900);padding:0 .825rem;height:44px;min-height:0;min-width:44px}.v-button-group .v-button--small{height:35px}.v-button-group .v-button:focus,.v-button-group .v-button:hover{background-color:#e4e4e4;color:var(--g-color-gray-900)}.v-button-group .v-button.v-button--active{background-color:#d0d0d0}.v-button-group .v-button:first-child{border-radius:var(--g-border-radius-standard) 0 0 var(--g-border-radius-standard)}.v-button-group .v-button:last-child{margin-right:0;border-radius:0 var(--g-border-radius-standard) var(--g-border-radius-standard) 0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };